import React, { useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Card,
  CardContent,
  Paper,
  CircularProgress
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRoleDetailsRequest } from "../../redux/Roles/actions/RolesActions";
import { EDIT_ROLE, ROLES } from "../../component/common/Routes/AppRoutes";
import "../../styles/ViewRoleForm.css";
import Loading from "../../component/ui/Loading";

const ViewRoleForm = () => {
  const user = useSelector((state) => state.auth.user);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
const page= location.state?.page?? 1;
const searchQuery=location.state?.searchQuery??"";
  const rolePermissions = useMemo(() => {
    let safePermissions = {};

    try {
      if (user?.permissions) {
        safePermissions =
          typeof user.permissions === "string"
            ? JSON.parse(user.permissions)
            : user.permissions;
      }
    } catch (error) {
      safePermissions = {};
    }

    return safePermissions;
  }, [user]);


  const { roleData } = location.state || {};
  const { roleDetails, loading, error } = useSelector(
    (state) => state.roles || {}
  );

  const roleDetail = useSelector((state) => state.roles || {});
  const viewLoading = roleDetail?.loading;
  const editLoading = roleDetail?.deleteLoading;

  const roleId = roleData?.id;

  useEffect(() => {
    if (roleId) {
      dispatch(fetchRoleDetailsRequest(roleId));
    }
  }, [dispatch, roleId]);

  if (error) {
    return (
      <Box className="view-role-container">
        <Typography variant="h6" color="error">
          {error}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(ROLES)}
        >
          Back to Roles
        </Button>
      </Box>
    );
  }

  const currentRoleData = roleData || roleDetails.data;

  if (!currentRoleData) {
    return (
      <Box className="view-role-container">
        <Typography variant="h6" color="error">
          No role data available to display.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className="back-button"
          onClick={() => navigate(ROLES)}
        >
          Back to Roles
        </Button>
      </Box>
    );
  }

  const { name, permissions, status } = currentRoleData;
  const permissionsList = [
    "add",
    "view",
    "edit",
    "delete",
    "allaccess",
    "noaccess"
  ];

  if (viewLoading) {
    return <Loading text="Loading Role Details..." />;
  }

  const renderPermissionCell = (menu, perm, value) => {
    if (
      (menu.toLowerCase() === "invoices" || menu.toLowerCase() === "reports") &&
      (perm === "add" ||
        perm === "view" ||
        perm === "edit" ||
        perm === "delete")
    ) {
      return "-";
    } else {
      return value ? "✔" : "✖";
    }
  };

  return (
    <Box className="role-permission-container">
      <Card>
        <CardContent className="card">
          <Typography variant="h5" gutterBottom className="form-heading">
            View Role
          </Typography>
          <Box className="role-details">
            <Typography variant="h6" className="role-name">
              Role Name: <span className="role-name-value">{name}</span>
            </Typography>
          </Box>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="table-category">Menu</TableCell>
                  {permissionsList.map((perm) => (
                    <TableCell key={perm} className="table-category">
                      {perm.charAt(0).toUpperCase() + perm.slice(1)}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {permissions &&
                  Object.keys(permissions).map((menu) => (
                    <TableRow key={menu}>
                      <TableCell className="table-category">{menu}</TableCell>
                      {permissionsList.map((perm) => (
                        <TableCell
                          key={perm}
                          className={`table-permission ${
                            (menu.toLowerCase() === "invoices" ||
                              menu.toLowerCase() === "reports") &&
                            (perm === "add" ||
                              perm === "view" ||
                              perm === "edit" ||
                              perm === "delete")
                              ? ""
                              : permissions[menu][perm]
                              ? "allowed"
                              : "denied"
                          }`}
                        >
                          {renderPermissionCell(
                            menu,
                            perm,
                            permissions[menu][perm]
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box className="role-status">
            <Typography className="view-status-label">Status:</Typography>
            <Typography
              className={`view-status-value ${
                status === 0
                  ? "view-status-active"
                  : status === 1
                  ? "view-status-inactive"
                  : "view-status-unknown"
              }`}
            >
              {status === 0 ? "Active" : status === 1 ? "Inactive" : "Unknown"}
            </Typography>
          </Box>
          <Box className="button-container">
            <Button
              variant="contained"
              className="cancel-button"
              onClick={() => navigate(ROLES,{state:{page:page,searchQuery:searchQuery}})}
            >
              Back
            </Button>
            {(user?.user_type === 1 || rolePermissions?.roles?.edit) && (
              <Button
                variant="contained"
                className="success-button"
                onClick={() =>
                  navigate(EDIT_ROLE, { state: { roleData: currentRoleData } })
                }
              >
                Edit
              </Button>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ViewRoleForm;
